import { render, staticRenderFns } from "./TasksLogs.vue?vue&type=template&id=0d3e92c4&"
import script from "./TasksLogs.vue?vue&type=script&lang=js&"
export * from "./TasksLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports